<template>
    
    <div class="row">

        <div class="col-md-4">
            <!-- Form Input -->
            <div class="form-group">
                <label for="tipo_cargo_profesor_id">Tipo:</label>
                <select name="tipo_cargo_profesor_id" v-model="tipo_cargo_profesor_id" class="form-control" @change="ActualizaTipoCargoProfesor" :required="obligatorio">
                    <option value="">Seleccione tipo</option>
                    <option v-for="tipo_cargo_profesor in tipos_cargo_profesor" :value="tipo_cargo_profesor.id" :key="'tipo_cargo_profesor-' + tipo_cargo_profesor.id">{{ tipo_cargo_profesor.nombre }}</option>
                </select>
            </div>
        </div>

        <div class="col-md-4" v-if="tipo_cargo_profesor_id == 1">
            <!-- Form Input -->
            <div class="form-group" :class="(obligatorio) ? 'form-group-required' : ''">
                <label for="cargo_die_id">Cargo DIE:</label>
                <select v-if="cargos_die.length > 0" name="cargo_die_id" v-model="cargo_die_id" class="form-control" :required="obligatorio">
                    <option value="">Seleccione cargo DIE</option>
                    <option v-for="cargo_die in cargos_die" :value="cargo_die.id" :key="'cargo_die-' + cargo_die.id">{{ cargo_die.nombre }}</option>
                </select>
                <select v-else class="form-control" :required="obligatorio">
                    <option value="">No hay cargos DIE disponibles</option>
                </select>
            </div>
        </div>

        <div class="col-md-4" v-if="tipo_cargo_profesor_id == 2 || tipo_cargo_profesor_id == 3">
            <!-- Form Input -->
            <div class="form-group" :class="(obligatorio) ? 'form-group-required' : ''">
                <label for="nombre">Nombre cargo</label>
                <input type="text" name="nombre" v-model="nombre" class="form-control" maxlength="191" placeholder="Nombre cargo" :required="obligatorio">
            </div>
        </div>

        <div class="col-md-4" v-if="tipo_cargo_profesor_id == 3">
            <!-- Form Input -->
            <div class="form-group" :class="(obligatorio) ? 'form-group-required' : ''">
                <label for="institucion">Institución</label>
                <input type="text" name="institucion" v-model="institucion" class="form-control" maxlength="191" placeholder="Institución" :required="obligatorio">
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        data() {
            return {
                cargo_die_id: null,
                cargos_die: [],
                institucion: '',
                nombre: '',
                tipo_cargo_profesor_id: null,
                tipos_cargo_profesor: [],
            }
        },
        props: {
            prop_cargo_die_id: {required: false, default: null},
            prop_institucion: {required: false, default: null},
            prop_nombre: {required: false, default: null},
            prop_tipo_cargo_profesor_id: {required: false, default: null},
            obligatorio: {required: false, default: false},
        },
        mounted() {
            this.CargarCargosDIE();
            this.CargarTiposCargoProfesor();

            if(this.prop_nombre)
                this.nombre = this.prop_nombre;

            if(this.prop_institucion)
                this.institucion = this.prop_institucion;
        },
        methods: {
            ActualizaTipoCargoProfesor() {
                
            },
            CargarCargosDIE() {
                const self = this;

                window.axios
                    .get('/data/cargos-die')
                    .then(function(response){

                        self.cargos_die = response.data.cargos_die;

                        if(self.prop_cargo_die_id) {
                            self.cargo_die_id = self.prop_cargo_die_id;
                        }
                        
                    })
                    .catch(function (error) {
                        window.NotificarError(error);
                    });
            },
            CargarTiposCargoProfesor() {
                const self = this;
                
                window.axios
                    .get('/data/tipos-cargo-profesor')
                    .then(function(response){

                        self.tipos_cargo_profesor = response.data.tipos_cargo_profesor;

                        if(self.prop_tipo_cargo_profesor_id) {
                            self.tipo_cargo_profesor_id = self.prop_tipo_cargo_profesor_id;
                        }

                    })
                    .catch(function (error) {
                        window.NotificarError(error);
                    });
            }
        }
    }
</script>
